module.exports = __webpack_public_path__ + "fonts/GraphikWide-Bold.woff";